import React from 'react';

const PageShapes = () => (
     <div className="page-shapes" aria-hidden="true">
          <div className="ps-shape ps-shape-1" />
          <div className="ps-shape ps-shape-2" />
          <div className="ps-shape ps-shape-3" />
          <div className="ps-shape ps-shape-4" />
     </div>
);

export default PageShapes;
